export default __webpack_public_path__ + "static/media/ugrad.b06ebdd8.png";